window.swymcsWishlistFunctions = window.swymcsWishlistFunctions || {
  addToWishlist: function (swat, product) {
    try {
      swat.addToList &&
        swat.addToList(product).then(function () {
          // Visual state update
          document
            .querySelectorAll('.swymcs-wishlist-button-' + product.empi)
            .forEach((b) => b.classList.add('swym-added-custom'));
        });
    } catch (e) {}
  },
  removeFromWishlist: function (swat, product) {
    try {
      swat.removeFromList &&
        swat.removeFromList(product).then(function () {
          document
            .querySelectorAll('.swymcs-wishlist-button-' + product.empi)
            .forEach((b) => b.classList.remove('swym-added-custom'));
        });
    } catch (e) {}
  },
  renderPopup: function (product) {
    // If you want to use Swym’s modal/popup on collections
    if (window._swat && _swat.ui && _swat.ui.createAddToWishlist) {
      _swat.ui.createAddToWishlist({ product });
    }
  },
};
